import Vue from 'vue';
import CONFIG from '../config';
import RolesPlugin from './roles';
import {AxiosAuthHttp} from '@/plugins/axios-http';
import axios from 'axios';
import router from '@/router';

Vue.use(RolesPlugin);

const api = AxiosAuthHttp.createNewClient({
    axios,
    resourceId: CONFIG.azureAd.clientId,
    router,
    baseUrl: `${CONFIG.apiBaseUrl}/api`
});

Vue.use({
    install(vue) {
        vue.prototype.$api = api;
    }
});

export const Api = api;
